/* eslint-disable react-hooks/exhaustive-deps */
import { Button, Tooltip } from 'antd'
import { useTranslation } from 'next-i18next'
import { EyeOutlined } from '@ant-design/icons'
import { UserSaleOffer } from 'src/core/models'
import React, { useState, useEffect } from 'react'
import { useAppDispatch, useAppSelector, useWindowSize } from 'src/app/hooks'
import { CustomModal, ProjectDetails, CustomResultModal } from 'src/components'
import SaleOfferPreviewContent from './SaleOfferPreviewContent/SaleOfferPreviewContent'
import {
  resetCounterSaleOfferState,
  resetSaleOfferDetailsState,
  resetAcceptSaleOfferState,
  counterSaleOffferSelector,
  resetRejectSaleOfferState,
  saleOffferDetailsSelector,
  rejectSaleOffferSelector,
  acceptSaleOffferSelector,
  getUserSaleOfferDetails,
} from 'src/features'

const SaleOfferDetailsButton: React.FC<{ offer: UserSaleOffer }> = ({ offer }) => {
  const { t } = useTranslation()
  const { isMobile } = useWindowSize()
  const dispatch = useAppDispatch()
  const [isModalVisible, setIsModalVisible] = useState<boolean>(false)
  const [isMakeCounterModalVisible, setIsMakeCounterModalVisible] = useState<boolean>(false)
  const [isRejectResultsModalVisible, setIsRejectResultsModalVisible] = useState<boolean>(false)
  const { currenctOfferId, loading, saleOffer } = useAppSelector(saleOffferDetailsSelector)

  /* Accept Selector */
  const {
    currenctOfferId: offerIdAccept,
    success: successAccept
  } = useAppSelector(acceptSaleOffferSelector)

  /* Counter Offer Selector */
  const {
    currenctOfferId: offerIdMakeCounter,
    success: successCounterOffer
  } = useAppSelector(counterSaleOffferSelector)

  /* Reject selector */
  const {
    currenctOfferId: offerIdReject,
    success: successReject
  } = useAppSelector(rejectSaleOffferSelector)


  useEffect(() => {
    if (saleOffer && currenctOfferId == offer.id) { setIsModalVisible(true) }
  }, [saleOffer])

  /* Handle Accept to close Modal */
  useEffect(() => {
    if (successAccept && offerIdAccept == offer.id) {
      setIsModalVisible(false)
      dispatch(resetSaleOfferDetailsState())
      dispatch(resetAcceptSaleOfferState())
    }
  }, [successAccept])

  /* Handle Make Counter to close modal */
  useEffect(() => {
    if (successCounterOffer && offerIdMakeCounter == offer.id) {
      setIsModalVisible(false)
      setIsMakeCounterModalVisible(true)
      dispatch(resetSaleOfferDetailsState())
      dispatch(resetCounterSaleOfferState())
    }
  }, [successCounterOffer])

  /* Handle Reject response to close modal */
  useEffect(() => {
    if (successReject && offerIdReject == offer.id) {
      setIsModalVisible(false)
      setIsRejectResultsModalVisible(true)
      dispatch(resetSaleOfferDetailsState())
      dispatch(resetRejectSaleOfferState())
    }
  }, [successReject])

  /* Handle Project Preview modal close */
  const handleModalClose = () => {
    setIsModalVisible(false)
    dispatch(resetSaleOfferDetailsState())
  }

  return <>
    <Tooltip color='blue' title={t('SalesOffer.CheckDetails')}>
      <Button
        type='ghost'
        size='middle'
        shape='circle'
        loading={loading && currenctOfferId === offer.id}
        className={isMobile ? 'radius-100 mr-3' : 'radius-100'}
        onClick={() => dispatch(getUserSaleOfferDetails(offer.id))}
        icon={<EyeOutlined />}
      />
    </Tooltip>

    {/* Preview Modal */}
    <CustomModal
      title={t('SalesOffer.Preview')}
      footer={null}
      open={isModalVisible}
      onCancel={handleModalClose}
      centered
      width={1000}
    >
      {saleOffer?.project && <ProjectDetails
        project={saleOffer.project}
        saleOfferContent={<SaleOfferPreviewContent offer={offer} />}
      />}
    </CustomModal>

    {/* Make counter offer results */}
    <CustomResultModal
      isModalVisible={isMakeCounterModalVisible}
      handleCancel={() => setIsMakeCounterModalVisible(false)}
      resultType='success'
      mainLabel={t('SalesOffer.SuccessCounter')}
    />

    {/* Reject Offer Results Modal */}
    <CustomResultModal
      isModalVisible={isRejectResultsModalVisible}
      handleCancel={() => setIsRejectResultsModalVisible(false)}
      resultType='info'
      mainLabel={t('SalesOffer.RejectTitle')}
      extra={t('SalesOffer.RejectSubtitle')}
    />
  </>
}

export default SaleOfferDetailsButton
